import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useDeveloperTermsQuery.ts
var r = (r = !0) => t({
	queryKey: e.terms(),
	queryFn: () => n.terms(),
	enabled: r
});
//#endregion
export { r as useDeveloperTermsQuery };
